export const TOP = 102

export const LINE_HEIGHT = 34

export const MASK_HEIGHT = LINE_HEIGHT * 7
